import config from '../Utils/config.js';

const Api = {
  uploadPattern: config.interfaceUrl + "/coll-log/video-websites/upload/pattern",  //上传pattern文件
  createPattern: config.interfaceUrl + "/coll-log/video-websites/create/pattern",  //创建pattern
  editPattern: config.interfaceUrl + "/coll-log/video-websites/edit/pattern",      //编辑pattern
  getQrCode: config.interfaceUrl + "/coll-log/video-websites/generate/qrCode",     //获取二维码或唤起app的短码
  getPattern: config.interfaceUrl + "/coll-log/video-websites/get/pattern",        //查询pattern
  getToken: config.interfaceUrl + "/coll-log/video-websites/ws/init",              //初始化，获取配置的socket连接
  createRecord: config.interfaceUrl + "/coll-log/video-websites/creator/record",   //创建pattern数据埋点
  audienceRecord: config.interfaceUrl + "/coll-log/video-websites/audience/record",//观众埋点
  getTimeStamp: config.interfaceUrl + "/coll-log/api/server/timestamp",        //获取服务器时间戳
  getLang: config.getLang + "/date-web-api/appTranslation/web/getLang",        //获取多语言信息
}

export default Api;